module.exports = __webpack_public_path__ + "static/media/warning.475281bd.svg";